import { Button, Field, NumericInput } from 'Components/Core';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { isNil } from 'ramda';
import { useState } from 'react';
import { ConfirmBulkAddRowsDialog } from './ConfirmBulkAddRowsDialog';

interface IBulkAddRowsFieldSection {
  onClick: (rowsToAdd: number) => any;
  visible: boolean;
  disabled: boolean;
}

const BulkAddRowsFieldSection: React.FC<IBulkAddRowsFieldSection> = ({ onClick, visible, disabled }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [rowsToAdd, setRowsToAdd] = useState<number | null>(null);
  const handleAddRowsClick = () => {
    if (isNil(rowsToAdd) || rowsToAdd === 0) {
      return;
    }
    if (rowsToAdd > 30) {
      setIsDialogVisible(true);
    } else {
      handleClick();
    }
  };

  const handleClick = () => {
    setRowsToAdd(null);
    setIsDialogVisible(false);
    onClick(rowsToAdd!);
  };

  const handleOnChange = (value: any) => {
    setRowsToAdd(Number.isInteger(value) && value >= 0 ? value : null);
  };

  return (
    <ListFieldSection visible={visible}>
      <FieldSet>
        <Field
          disabled={disabled}
          input={<NumericInput />}
          label="Rows to Add"
          value={rowsToAdd}
          onChange={(e: any) => handleOnChange(e.data.value)}
        />
        <ListFieldSection>
          <ConfirmBulkAddRowsDialog
            visible={isDialogVisible}
            rowsToAdd={rowsToAdd ?? 0}
            onCancel={() => setIsDialogVisible(false)}
            onConfirm={handleClick}
          />
          <Button disabled={disabled} onClick={handleAddRowsClick}>
            Add Rows
          </Button>
        </ListFieldSection>
      </FieldSet>
    </ListFieldSection>
  );
};

export { BulkAddRowsFieldSection };
